import YandexMap from "./yandexMap";
import Notify from "./../notify";
import Litepicker from "./../litepicker";

export default class Event {
    constructor(id = false) {
        this.yandexMapModal;
        this.settings = {
            formId: id,
            yandexMapKey: "9d74d587-aa73-40f2-89ee-05cd873d4f17",
            containerItems: "session__container",
            containerButtonCreate: "button-create-container",
            sessionItem: "session__item",
            sessonItemControl: "session__item-control",
            sessionCreateButton: "session__create",
            delButtonsClass: ".del-button",
            defaultStep: 1,
            breadcrumbContainer: "breadcrumbs-container",
            nextstepbutton1: "next-step-1",
            nextstepbutton2: "next-step-2",
            nextstepbutton3: "next-step-3",
            cancelButton: "event-cancel",
            navigationContainer: "navigation-buttons",
        };
        this.serializeDataArray = {};
        this.counterSession = 1;
        this.numberSession = 1;
        this.counterServices = 1;
        this.step = {
            innerStep1: null,
            step1Id: "step-1",
            innerStep2: null,
            step2Id: "step-2",
            innerStep3: null,
            step3Id: "step-3",
        };

        this.breadcrumbsStep1 =
            "<div class='sect'>" +
            "<span>Даты</span>" +
            "<span class='sect_dark'>&nbsp; — &nbsp;</span>" +
            "<span class='sect_dark'>Описание</span>" +
            "<span class='sect_dark'>&nbsp; — &nbsp;</span>" +
            "<span class='sect_dark'>Стоимость</span>" +
            "</div>";

        this.breadcrumbsStep2 =
            "<div class='sect'>" +
            "<span class='sect_dark'>Даты</span>" +
            "<span class='sect_dark'>&nbsp; — &nbsp;</span>" +
            "<span>Описание</span>" +
            "<span class='sect_dark'>&nbsp; — &nbsp;</span>" +
            "<span class='sect_dark'>Стоимость</span>" +
            "</div>";
        this.breadcrumbsStep3 =
            "<div class='sect'>" +
            "<span class='sect_dark'>Даты</span>" +
            "<span class='sect_dark'>&nbsp; — &nbsp;</span>" +
            "<span class='sect_dark'>Описание</span>" +
            "<span class='sect_dark'>&nbsp; — &nbsp;</span>" +
            "<span>Стоимость</span>" +
            "</div>";
    }
    createBreadcrumbs1() {
        let newBreadcrumbs = document.getElementById(
            this.settings.breadcrumbContainer
        );
        if (newBreadcrumbs != null) {
            newBreadcrumbs.innerHTML = this.breadcrumbsStep1;
        }
    }
    createBreadcrumbs2() {
        let newBreadcrumbs = document.getElementById(
            this.settings.breadcrumbContainer
        );
        newBreadcrumbs.innerHTML = this.breadcrumbsStep2;
    }
    createBreadcrumbs3() {
        let newBreadcrumbs = document.getElementById(
            this.settings.breadcrumbContainer
        );
        newBreadcrumbs.innerHTML = this.breadcrumbsStep3;
    }
    createNavigationButtons1() {
        let navigation = document.getElementById(this.settings.navigationContainer);
        if (navigation != null) {
            navigation.innerHTML =
                "<div class='cell auto medium-shrink'><button class='button clear'  id='event-cancel' type='button'>Отмена</button></div>" +
                "<div class='cell shrink medium-shrink'><button class='button solid' id='next-step-1' type='button' >Далее</button></div>";
        }
    }
    createNavigationButtons2() {
        let navigation = document.getElementById(this.settings.navigationContainer);

        if (navigation != null) {
            navigation.innerHTML =
                "<div class='cell auto medium-shrink'><button class='button clear'  id='event-prev-2' type='button'>Назад</button></div>" +
                "<div class='cell shrink medium-shrink'><button class='button solid' id='next-step-2' type='button' >Далее</button></div>";
        }
    }
    createNavigationButtons3() {
        let navigation = document.getElementById(this.settings.navigationContainer);

        if (navigation != null) {
            navigation.innerHTML =
                "<div class='cell auto medium-shrink'><button class='button clear'  id='event-prev-3' type='button'>Назад</button></div>" +
                "<div class='cell shrink medium-shrink'><button type='submit' class='button solid' id='next-step-3' type='button' >Опубликовать</button></div>";
        }
    }
    createButtonAddSession() {
        let buttonTemplate =
            "<div class='cell medium-8'>" +
            "<button id='session__create' class='button hollow expanded' type='button'><i class='fa fa-plus'></i> Добавить ещё сеанс</button>" +
            "</div>";
        if (document.getElementById(this.settings.containerButtonCreate) != null) {
            let newSession = document.getElementById(
                this.settings.containerButtonCreate
            );
            newSession.innerHTML = buttonTemplate;
        }
    }

    createStep2() {
        let container = document.getElementById(this.step.step2Id);
        if (container) {
            container.innerHTML =
                "<label>Название мероприятия" +
                "<input  data-required='Y' name='name' class='textfield'>" +
                "</label>" +
                "<label>Описание мероприятия" +
                "<textarea  data-required='Y' name='description-name' rows='5'></textarea>" +
                "</label>" +
                "<div class='sect'>Место сбора<br />" +
                "<a id='change-addres' data-modal='map-modal'>Указать на Яндекс Карте <i class='far fa-clone'></i></a>" +
                "</div>" +
                "<label>Указан адрес" +
                "<textarea data-required='Y'  id='addres' name='addres' disabled='disabled'></textarea>" +
                "<input type='hidden'  id='coords' name='coords' >" +
                "<label>Пояснения к месту сбора" +
                "<textarea  name='addres-description' placeholder='Например: на углу у дома №25, напротив остановки'></textarea>" +
                "</label>" +
                "<div style='height:70%;' class='reveal small' id='yandex-map-modal'>" +
                "<div class=''  id='event-map' style='width:100%;height:100%;max-height:100%;padding:15px;'>" +
                "</div>" +
                "<button class='close-button' type='button' id='yandex-map-close' data-close aria-label='Закрыть'>" +
                "<span aria-hidden='true'>&times;</span>" +
                "</button>" +
                "</div>";

            let map = new YandexMap("event-map", "addres");
            map.run();
        }
    }

    createStep3() {
        let instance = this;
        let containerCounts = document.getElementById("step-3-container-counts");
        if (containerCounts) {
            containerCounts.innerHTML =
                "<label>Количество мест" +
                "<div class='grid-x'>" +
                "<div class='cell medium-6'>" +
                "<div class='js-spinner input-group'>" +
                "<div class='input-group-button'><button class='button light-gray' type='button' spinner-button='down'>–</button></div>" +
                "<input data-required='Y' name='count-place' class='count-place-create input-group-field textfield text-center js-stepper' type='number' step='1' max='999' min='0' value='1' data-stepper-debounce='400' />" +
                "<div class='input-group-button'><button class='button light-gray' type='button' spinner-button='up'>+</button></div>" +
                "</div>" +
                "</div>" +
                "</div>" +
                "</label>" +
                "<label>Стоимость места" +
                "<div class='grid-x'>" +
                "<div class='cell medium-6'>" +
                "<div class='input-group'>" +
                "<input name='price-place' type='number' data-required='Y' class='textfield input-group-field' /><label  class='input-group-label'>руб</label></div>" +
                "</div>" +
                "</div>" +
                "</label>" +
                "<label>За какое время до начала сеанса закрыть продажу билетов, часов" +
                "<div class='grid-x'>" +
                "<div class='cell medium-6'>" +
                "<div class='js-spinner input-group'>" +
                "<div class='input-group-button'><button class='button light-gray' type='button' spinner-button='down'>–</button></div>" +
                "<input data-required='Y' name='close-hour' class='input-group-field textfield text-center js-stepper' type='number' step='1' max='999' min='0' value='12' data-stepper-debounce='400' />" +
                "<div class='input-group-button'><button class='button light-gray' type='button' spinner-button='up'>+</button></div>" +
                "</div>" +
                "</div>" +
                "</div>" +
                "</label><br>";
        }

        let containerService = document.getElementById("step-3-container-services");
        let servicetitle = document.getElementById("service-title");
        if (servicetitle) {
            servicetitle.innerHTML =
                "<div><b>Дополнительные услуги</b></div>" +
                "<br class='hide-for-medium' />" +
                "<div class='grid-x grid-padding-x sect_dark show-for-medium'>" +
                "<div class='cell medium-11'>Название</div>" +
                "<div class='cell medium-5'>Цена</div>" +
                "<div class='cell medium-6'>Количество</div>" +
                "</div>";
        } else if (containerService) {
            containerService.innerHTML =
                "<div><b>Дополнительные услуги</b></div>" +
                "<br class='hide-for-medium' />" +
                "<div class='grid-x grid-padding-x sect_dark show-for-medium'>" +
                "<div class='cell medium-11'>Название</div>" +
                "<div class='cell medium-5'>Цена</div>" +
                "<div class='cell medium-6'>Количество</div>" +
                "</div>";
        }
        this.createService();
        this.createService();
        let containerButtonServiceCreate = document.getElementById(
            "button-services-create-container"
        );
        if (containerButtonServiceCreate) {
            containerButtonServiceCreate.innerHTML =
                "<button id='service-create' class='button hollow' type='button'><i class='fa fa-plus'></i> Добавить услугу</button>";
        }
        let containerLinks = document.getElementById("step-3-container-links");
        if (containerLinks) {
            containerLinks.innerHTML =
                "<label>Адрес страницы «Спасибо»<input data-required='Y' name='thanks-link' class='textfield' placeholder='http://www.' /></label>" +
                "<label>" +
                "Cсылка на страницу тура <span data-tooltip title='Будет на странице ошибки, в ссылке «вернуться на страницу тура»'>" +
                "<i class='fa fa-lg fa-info-circle'></i> </span><input  data-required='Y'  name='link-tour' class='textfield' placeholder='http://www.' />" +
                "</label>";
        }

        $("input[name='close-hour']").stepper();
        $(".count-place-create").stepper();

        let buttonCreate = document.getElementById("service-create");

        if (buttonCreate != null) {
            buttonCreate.addEventListener("click", function() {
                instance.createService();
            });
        }
    }

    createService() {
        let elemCounter = $(".service-element").length;
        if (elemCounter > 0) {
            this.counterServices = elemCounter + 1;
        }

        let newElement = document.createElement("div");
        newElement.classList.add("service-element");
        newElement.innerHTML =
            "<div data-create='Y'  data-item='" +
            this.counterServices +
            "' class='grid-x grid-padding-x'><div class='cell medium-11'><input name='service-name-" +
            this.counterServices +
            "' class='textfield' placeholder='Название' /></div>" +
            "<div class='cell medium-5'>" +
            "<div class='input-group'><input name='service-price-" +
            this.counterServices +
            "' class='textfield input-group-field' placeholder='Цена' /><label class='input-group-label'>руб</label></div>" +
            "</div>" +
            "<div class='cell auto medium-6'>" +
            "<div class='sect_dark hide-for-medium'>Доступное количество</div>" +
            "<div class='js-spinner input-group'>" +
            "<div class='input-group-button'><button class='button light-gray' type='button' spinner-button='down'>–</button></div>" +
            "<input name='service-count-" +
            this.counterServices +
            "' class='input-group-field textfield text-center js-stepper' type='number' step='1' max='999' min='0' value='1' data-stepper-debounce='400' />" +
            "<div class='input-group-button'><button class='button light-gray' type='button' spinner-button='up'>+</button></div>" +
            "</div>" +
            "</div>" +
            "<div class='cell shrink medium-2'>" +
            "<br class='hide-for-medium' />" +
            "<button data-delete='del-" +
            this.counterServices +
            "' class='button clear alert' type='button' title='Удалить услугу'><i class='fas fa-trash'></i></button>" +
            "</div> </div><br class='hide-for-medium' />";

        let servicesContainer = document.getElementById(
            "step-3-container-services"
        );
        if (servicesContainer != null) {
            servicesContainer.appendChild(newElement);
            this.initdeleteserviceButton(
                document.querySelectorAll(
                    "[data-delete='del-" + this.counterServices + "']"
                )[0]
            );
            $("input[name='service-count-" + this.counterServices + "']").stepper();

            this.counterServices++;
        }
    }
    createSession() {
        if (this.counterSession <= 1) {
            let elemCounter = $(".session__item").length;
            if (elemCounter > 0) {
                this.counterSession = elemCounter + 1;
            }
        }

        let newElement = document.createElement("div");
        newElement.classList.add(
            this.settings.sessionItem,
            "callout",
            this.settings.sessonItemControl + "-" + this.counterSession
        );
        newElement.setAttribute("data-create", "Y");
        newElement.innerHTML =
            "<div class='grid-x grid-padding-x align-justify'>" +
            "<div class='cell medium-auto'>" +
            "<div class='sect'><b>Сеанс №" +
            this.counterSession +
            "</b></div>" +
            "<label>Время начала сеанса</label>" +
            "<div class='grid-x'>" +
            "<div class='cell medium-6'><input data-required='Y' name='event-time-" +
            this.counterSession +
            "' class='textfield' data-timepicker placeholder='ЧЧ:ММ' /></div>" +
            "</div>" +
            "<div class='flex-container align-top'>" +
            "<div class='flex-child-shrink'><input checked class='picture' type='radio' id='event-mode-" +
            this.counterSession +
            "' name='event-mode-" +
            this.counterSession +
            "' value='dates' /></div>" +
            "<div class='flex-child-auto'>" +
            "<label for='event-mode-" +
            this.counterSession +
            "'>Один или несколько дней календаря</label>" +
            "<div class='input-group' _data-toggle='calendar-dropdown'>" +
            "<div class='input-group-label'><i class='fas fa-calendar'></i></div>" +
            "<textarea  data-required='Y' id='events-data-datemultipicker-" +
            this.counterSession +
            "' name='event-multidate-" +
            this.counterSession +
            "' class='input-group-field event-multidates-input' rows='2' events-data-datemultipicker-" +
            this.counterSession +
            ">" +
            // +"5.03.2020, 9.03.2020, 12.03.2020, 15.03.2020, 18.03.2020, 22.03.2020, 25.03.2020, 1.04.2020, 3.04.2020"
            "</textarea>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "<div class='flex-container align-top'>" +
            "<div class='flex-child-shrink'>" +
            "<input class='picture' type='radio' id='event-mode-range-" +
            this.counterSession +
            "' name='event-mode-" +
            this.counterSession +
            "' value='days' />" +
            "</div>" +
            "<div class='flex-child-auto'>" +
            "<label for='event-mode-range-" +
            this.counterSession +
            "'>Или дни сеанса</label>" +
            "<div class='grid-x grid-padding-x'>" +
            "<div class='cell shrink'>" +
            "<label><input name='event-day-" +
            this.counterSession +
            "' value='monday' type='checkbox' />Пн</label>" +
            "</div>" +
            "<div class='cell shrink'>" +
            "<label><input name='event-day-" +
            this.counterSession +
            "' value='tuesday' type='checkbox' />Вт</label>" +
            "</div>" +
            "<div class='cell shrink'>" +
            "<label><input name='event-day-" +
            this.counterSession +
            "' value='wednesday' type='checkbox' />Ср</label>" +
            "</div>" +
            "<div class='cell shrink'>" +
            "<label><input name='event-day-" +
            this.counterSession +
            "'  value='thursday' type='checkbox' />Чт</label>" +
            "</div>" +
            "<div class='cell shrink'>" +
            "<label><input name='event-day-" +
            this.counterSession +
            "'  value='friday' type='checkbox' />Пт</label>" +
            "</div>" +
            "<div class='cell shrink'>" +
            "<label><input name='event-day-" +
            this.counterSession +
            "'  value='saturday' type='checkbox' />Сб</label>" +
            "</div>" +
            "<div class='cell shrink'>" +
            "<label><input name='event-day-" +
            this.counterSession +
            "'  value='sunday' type='checkbox' />Вс</label>" +
            "</div>" +
            "</div>" +
            "<div class='input-group'>" +
            "<label class='input-group-label show-for-medium'>В период</label>" +
            "<input data-required='Y' name='event-period-" +
            this.counterSession +
            "' class='textfield input-group-field' events-data-daterangepicker-" +
            this.counterSession +
            " placeholder='от даты — до даты' />" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>" +
            " <div class='cell medium-shrink'>" +
            "<br class='hide-for-medium' />" +
            "<button class='button hollow alert del-button' type='button' data-toggle='delete-event-prompt-dropdown-" +
            this.counterSession +
            "'>Удалить сеанс</button>" +
            "</div>" +
            "</div>" +
            "<div class='dropdown-pane' id='delete-event-prompt-dropdown-" +
            this.counterSession +
            "'  data-auto-focus='true'>" +
            "<div class='sect text-center'>Востановить будет нельзя!</div>" +
            "<button class='button alert expanded' data-confirm-ok='confirm-delete-ok-" +
            this.counterSession +
            "' type='button'>Да, удалить</button>" +
            "</div>" +
            "</div>";

        try {
            let sessionContainer = document.getElementById(
                this.settings.containerItems
            );
            if (sessionContainer != null) {
                sessionContainer.appendChild(newElement);
                this.initMultipleDate(
                    document.querySelectorAll(
                        "[events-data-datemultipicker-" + this.counterSession + "]"
                    )[0]
                );
                this.initTime($("[name='event-time-" + this.counterSession + "']"));
                this.initRangeDate(
                    document.querySelectorAll(
                        "[events-data-daterangepicker-" + this.counterSession + "]"
                    )[0]
                );

                this.inittoggleDeleteButton(
                    document.querySelectorAll(
                        "[data-toggle='delete-event-prompt-dropdown-" +
                        this.counterSession +
                        "']"
                    )[0]
                );
                this.initconfirmDeleteButton(
                    document.querySelectorAll(
                        "[data-confirm-ok='confirm-delete-ok-" + this.counterSession + "']"
                    )[0]
                );
                this.counterSession++;
                this.numberSession++;
            }
        } catch (err) {
            console.log(err);
        }
    }
    initMultipleDate(element) {
        new Litepicker({
            element: element,
            lang: "ru-RU",
            minDate: Date.now(),
            singleMode: true,
            numberOfMonths: 2,
            numberOfColumns: 2,
            autoApply: true,
            highlightedDaysFormat: "DD.MM.YYYY",
            onSelect: function(date) {
                var newDate,
                    str = "";
                var year = new Date(date).getFullYear();
                var day = new Date(date).getDate();
                var mounth = new Date(date).getMonth() + 1;
                if (mounth <= 9) {
                    mounth = "0" + mounth;
                }
                if (day <= 9) {
                    day = "0" + day;
                }
                newDate = day + "." + mounth + "." + year;

                if (this.options.element.value) {
                    str += this.options.element.value + "," + newDate;
                } else {
                    str = newDate;
                }
                this.options.element.value = str;
            },
        });
    }
    initTime(element) {
        $(element).inputmask({
            alias: "datetime",
            placeholder: "ЧЧ:ММ",
            inputFormat: "HH:MM",
            insertMode: false,
            showMaskOnHover: false,
            hourFormat: "24",
        });
    }
    initRangeDate(element) {
        let litepicker = new Litepicker({
            element: element,
            minDate: Date.now(),
            lang: "ru-RU",
            format: "DD.MM.YYYY",
            singleMode: false,
            numberOfMonths: 2,
            numberOfColumns: 2,
        });
        return litepicker;
    }

    inittoggleDeleteButton(element) {
        let id = element.getAttribute("data-toggle");

        new Foundation.Dropdown($("#" + id));
        // element.addEventListener("click", function (e) {
        //   e.preventDefault();

        // });
    }

    initconfirmDeleteButton(element) {
        element.addEventListener("click", function(e) {
            e.preventDefault();
            let parentSessionElement = this.parentNode.parentNode;
            parentSessionElement.remove();
            // this.counterSession--;
        });
    }
    initdeleteserviceButton(element) {
        element.addEventListener("click", function(e) {
            e.preventDefault();
            let parentServiceElement = this.parentNode.parentNode;

            parentServiceElement.remove();
        });
    }

    cancel() {
        document.location.href = "/";
    }
    step1Hide() {
        let step1Block = document.getElementById(this.step.step1Id);
        step1Block.style = "display:none";
    }
    step1show() {
        let step1Block = document.getElementById(this.step.step1Id);
        if (step1Block) {
            step1Block.style = "display:block";
        }
    }
    step2Hide() {
        let step2Block = document.getElementById(this.step.step2Id);
        if (step2Block) {
            step2Block.style = "display:none";
        }
    }
    step2Show() {
        let step2Block = document.getElementById(this.step.step2Id);

        if (step2Block) {
            step2Block.style = "display:block";
        }
    }
    step3Hide() {
        let step3Block = document.getElementById(this.step.step3Id);
        if (step3Block) {
            step3Block.style = "display:none";
        }
    }
    step3show() {
        let step3Block = document.getElementById(this.step.step3Id);
        if (step3Block) {
            step3Block.style = "display:block";
        }
    }
    step1() {
        this.step1show();
        this.step2Hide();
        this.step3Hide();
        this.createBreadcrumbs1();

        this.createButtonAddSession();
        this.createNavigationButtons1();
        var instance = this;
        let buttonCreate = document.getElementById(
            this.settings.sessionCreateButton
        );

        if (buttonCreate != null) {
            buttonCreate.addEventListener("click", function(e) {
                e.preventDefault();
                instance.createSession();
            });
        }
        let buttonNextStep1 = document.getElementById(
            this.settings.nextstepbutton1
        );
        if (buttonNextStep1 != null) {
            buttonNextStep1.addEventListener("click", function(e) {
                e.preventDefault();
                if (
                    document.getElementsByClassName(instance.settings.sessionItem)
                    .length >= 1
                ) {
                    // Обрабатываем первый шаг

                    instance.step2();
                } else {
                    new Notify("Необходимо добавить хотя бы 1 сеанс", "warning");
                }
            });
        }

        let buttonCancelStep1 = document.getElementById(this.settings.cancelButton);
        if (buttonCancelStep1 != null) {
            buttonCancelStep1.addEventListener("click", function() {
                instance.cancel();
            });
        }
    }

    step2() {
        var instance = this;
        this.step1Hide();
        this.step3Hide();
        this.step2Show();
        this.createBreadcrumbs2();
        this.createNavigationButtons2();

        let buttonNextStep2 = document.getElementById(
            this.settings.nextstepbutton2
        );

        if (buttonNextStep2 != null) {
            buttonNextStep2.addEventListener("click", function(e) {
                e.preventDefault();

                instance.step3();
            });
        }

        let buttonPrevstep2 = document.getElementById("event-prev-2");
        if (buttonPrevstep2 != null) {
            buttonPrevstep2.addEventListener("click", function() {
                instance.step1();
            });
        }

        var modal = $("#yandex-map-modal");
        if (!this.yandexMapModal) {
            this.yandexMapModal = new Foundation.Reveal(modal);
        }

        var buttonModalOpen = document.getElementById("change-addres");
        buttonModalOpen.addEventListener("click", function() {
            instance.yandexMapModal.open();
        });

        var btnCloseYandexMapModal = document.getElementById("yandex-map-close");
        btnCloseYandexMapModal.addEventListener("click", function() {
            instance.yandexMapModal.close();
        });
    }

    step3() {
        var instance = this;
        this.step2Hide();
        this.step3show();
        this.createBreadcrumbs3();
        this.createNavigationButtons3();

        let buttonPrevstep3 = document.getElementById("event-prev-3");
        if (buttonPrevstep3 != null) {
            buttonPrevstep3.addEventListener("click", function() {
                instance.step2();
            });
        }
    }
    collectDate(form) {
        var requiredError = false;

        let addres = document.getElementById("addres");
        if (addres) {
            addres.removeAttribute("disabled");
        }

        let data = $(form).serializeArray();
        if (addres) {
            addres.setAttribute("disabled", "disabled");
        }

        let serviceArray = [];
        let sessionArray = [];
        let commonArray = [];

        data.forEach((element) => {
            if (element.name.indexOf("event") != -1) {
                // let  indexElement = element.name.split("-");
                sessionArray.push(element);
            } else if (element.name.indexOf("service") != -1) {
                serviceArray.push(element);
            } else {
                commonArray.push(element);
            }
        });
        let resultSession = [];

        if (sessionArray.length > 0) {
            for (let i in sessionArray) {
                let indexElement = sessionArray[i].name.split("-")[2];

                if (Array.isArray(resultSession[indexElement])) {
                    resultSession[indexElement].push(sessionArray[i]);
                } else {
                    resultSession[indexElement] = [];
                    resultSession[indexElement].push(sessionArray[i]);
                }
            }
        }

        let resultService = [];
        if (serviceArray.length > 0) {
            serviceArray.forEach((element) => {
                let indexElement = element.name.split("-")[2];

                if (Array.isArray(resultService[indexElement])) {
                    resultService[indexElement].push(element);
                } else {
                    resultService[indexElement] = [];
                    resultService[indexElement].push(element);
                }
            });
        }

        let filteredResultSession = resultSession.filter(function(el) {
            return el != null;
        });

        let filteredResultService = resultService.filter(function(el) {
            return el != null;
        });

        let countSessionElements = document.getElementsByClassName(
            this.settings.sessionItem
        );

        if (countSessionElements.length > 0) {
            requiredError = false;

            for (let i = 1; i <= countSessionElements.length; i++) {
                let modeInputMulti = document.querySelectorAll(
                    "[name='event-multidate-" + i + "']"
                )[0];
                let modeInputRange = document.querySelectorAll(
                    "[name='event-period-" + i + "']"
                )[0];
                modeInputMulti.classList.remove("callout", "alert");
                modeInputRange.classList.remove("callout", "alert");

                let mode = document.querySelectorAll(
                    "[name='event-mode-" + i + "']:checked"
                )[0];

                let modeValue = mode.value;

                if (modeValue == "dates") {
                    filteredResultSession.forEach((element) => {
                        element.forEach((elementinner) => {
                            if (
                                "event-multidate-" + i == elementinner.name ||
                                "event-time-" + i == elementinner.name
                            ) {
                                let item = document.querySelectorAll(
                                    "[name=" + elementinner.name + "]"
                                )[0];
                                let reqiured = item.getAttribute("data-required");

                                if (reqiured == "Y") {
                                    if (!elementinner.value.trim() ||
                                        elementinner.value.trim().length == 0
                                    ) {
                                        item.classList.add("callout", "alert");

                                        if ("event-multidate-" + i == elementinner.name) {
                                            let margin = "margin:auto";
                                            item.style = margin;
                                        }

                                        if (!requiredError) {
                                            requiredError = true;
                                        }
                                    } else {
                                        if (
                                            item.classList.contains("callout") ||
                                            item.classList.contains("alert")
                                        ) {
                                            item.classList.remove("callout", "alert");
                                        }
                                    }
                                }
                            }
                        });
                    });
                } else if (modeValue == "days") {
                    filteredResultSession.forEach((element) => {
                        element.forEach((elementinner) => {
                            if (
                                "event-period-" + i == elementinner.name ||
                                "event-time-" + i == elementinner.name
                            ) {
                                let item = document.querySelectorAll(
                                    "[name=" + elementinner.name + "]"
                                )[0];
                                let reqiured = item.getAttribute("data-required");

                                if (reqiured == "Y") {
                                    if (!elementinner.value || elementinner.value.length == 0) {
                                        item.classList.add("callout", "alert");

                                        if (!requiredError) {
                                            requiredError = true;
                                        }
                                    } else {
                                        if (
                                            item.classList.contains("callout") ||
                                            item.classList.contains("alert")
                                        ) {
                                            item.classList.remove("callout", "alert");
                                        }
                                    }
                                }
                            }
                        });
                    });
                }
            }
        }

        let resultCommonArray = {};
        if (commonArray.length > 0) {
            commonArray.forEach((element) => {
                let item = document.querySelectorAll("[name=" + element.name + "]")[0];
                let reqiured = item.getAttribute("data-required");

                if (reqiured == "Y") {
                    if (!element.value || element.value.length == 0) {
                        item.classList.add("callout", "alert");

                        if (!requiredError) {
                            requiredError = true;
                        }
                    } else {
                        if (
                            item.classList.contains("callout") ||
                            item.classList.contains("alert")
                        ) {
                            item.classList.remove("callout", "alert");
                        }
                    }
                }
                resultCommonArray[element.name] = [];
                resultCommonArray[element.name] = element.value;
            });
        }

        let serviceNormalizeArray = {};

        if (filteredResultService.length > 0) {
            for (let i in filteredResultService) {
                filteredResultService[i].forEach((elementInner) => {
                    let indexElement = elementInner.name.split("-")[2];
                    if (typeof serviceNormalizeArray[indexElement] !== "object") {
                        serviceNormalizeArray[indexElement] = {};
                    }

                    if (elementInner.name.indexOf("service-name") != -1) {
                        serviceNormalizeArray[indexElement]["service-name"] = [];
                        serviceNormalizeArray[indexElement]["service-name"] =
                            elementInner.value;
                    }

                    if (elementInner.name.indexOf("service-price") != -1) {
                        serviceNormalizeArray[indexElement]["service-price"] = [];
                        serviceNormalizeArray[indexElement]["service-price"] =
                            elementInner.value;
                    }
                    if (elementInner.name.indexOf("service-count") != -1) {
                        serviceNormalizeArray[indexElement]["service-count"] = [];
                        serviceNormalizeArray[indexElement]["service-count"] =
                            elementInner.value;
                    }
                });
            }
        }

        //

        let sessionsNormalizeArray = {};

        if (filteredResultSession.length > 0) {
            for (let i in filteredResultSession) {
                filteredResultSession[i].forEach((elementInner) => {
                    let indexElement = elementInner.name.split("-")[2];
                    if (typeof sessionsNormalizeArray[indexElement] !== "object") {
                        sessionsNormalizeArray[indexElement] = {};
                    }

                    if (elementInner.name.indexOf("event-time") != -1) {
                        sessionsNormalizeArray[indexElement]["time"] = [];
                        sessionsNormalizeArray[indexElement][
                            "time"
                        ] = elementInner.value.trim();
                    }

                    if (elementInner.name.indexOf("event-mode") != -1) {
                        sessionsNormalizeArray[indexElement]["mode"] = [];
                        sessionsNormalizeArray[indexElement][
                            "mode"
                        ] = elementInner.value.trim();
                    }
                    if (elementInner.name.indexOf("event-multidate") != -1) {
                        sessionsNormalizeArray[indexElement]["multidate"] = [];
                        sessionsNormalizeArray[indexElement][
                            "multidate"
                        ] = elementInner.value.trim();
                    }

                    if (elementInner.name.indexOf("event-period") != -1) {
                        sessionsNormalizeArray[indexElement]["period"] = [];
                        sessionsNormalizeArray[indexElement][
                            "period"
                        ] = elementInner.value.trim();
                    }
                    if (elementInner.name.indexOf("event-day") != -1) {
                        if (Array.isArray(sessionsNormalizeArray[indexElement]["day"])) {
                            sessionsNormalizeArray[indexElement]["day"].push(
                                elementInner.value.trim()
                            );
                        } else {
                            sessionsNormalizeArray[indexElement]["day"] = [];
                            sessionsNormalizeArray[indexElement]["day"].push(
                                elementInner.value.trim()
                            );
                        }
                    }
                });
            }
        }

        this.serializeArray = {
            sessions: sessionsNormalizeArray,
            services: serviceNormalizeArray,
            common: resultCommonArray,
        };

        return requiredError;
    }

    alertErrorEmpty() {
        new Notify("Пожалуйста, заполните все  обязательные поля", "alert");
    }
    sendForm() {
        let instance = this;
        $.ajax({
            method: "POST",
            url: "/themes/ahtilahti/ajax/event_create.php",
            data: {
                action: "create_event",
                data: {
                    common: instance.serializeArray.common,
                    sessions: instance.serializeArray.sessions,
                    services: instance.serializeArray.services,
                },
            },
            success: function(response) {
                let res;
                typeof response === "string" ?
                    (res = $.parseJSON(response)) :
                    (res = response);

                if (res.success) {
                    new Notify(res.message, "success");
                    if (res.link) {
                        setTimeout(() => {
                            document.location.href = res.link;
                        }, 500);
                    }
                } else {
                    new Notify(res.message, "alert");
                }
            },
            error(xhr, status, error) {
                new Notify(error, "alert");
            },
        });
    }

    init() {
        let instance = this;

        if ($("." + this.settings.sessionItem).length <= 0) {
            this.createSession();
        } else {
            for (let i = 1; i <= $("." + this.settings.sessionItem).length; i++) {
                this.inittoggleDeleteButton(
                    document.querySelectorAll(
                        "[data-toggle='delete-event-prompt-dropdown-" + i + "']"
                    )[0]
                );
            }
        }

        this.createStep2();
        this.createStep3();
        this.step1();

        let submitBtn = document.getElementById(this.settings.formId);
        if (submitBtn != null) {
            submitBtn.addEventListener("submit", function(e) {
                e.preventDefault();

                let requiredError = instance.collectDate(this);
                if (requiredError == false) {
                    instance.sendForm();
                } else {
                    instance.alertErrorEmpty();
                }
            });
        }
    }
}